import { useEffect } from 'react';
import { trackPageView } from '../utils/analytics';

const CANONICAL_ORIGIN = 'https://podiumrun.com';

const setMetaTag = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (path) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', `${CANONICAL_ORIGIN}${path}`);
};

/**
 * Define title/description/OG por página e dispara o page_view do GA4.
 *
 * Necessário porque o site é uma SPA: sem isso, todas as rotas herdam o
 * <title> e o og:image do index.html, e compartilhar a página de treinador
 * renderiza o card de atleta.
 */
const PageMeta = ({ title, description, image, path, role, lang = 'pt' }) => {
  useEffect(() => {
    document.title = title;
    document.documentElement.lang = lang;

    setMetaTag('name', 'description', description);
    setMetaTag('property', 'og:type', 'website');
    setMetaTag('property', 'og:title', title);
    setMetaTag('property', 'og:description', description);
    setMetaTag('property', 'og:url', `${CANONICAL_ORIGIN}${path}`);
    setMetaTag('property', 'og:image', `${CANONICAL_ORIGIN}${image}`);
    setMetaTag('name', 'twitter:card', 'summary_large_image');
    setMetaTag('name', 'twitter:title', title);
    setMetaTag('name', 'twitter:description', description);
    setMetaTag('name', 'twitter:image', `${CANONICAL_ORIGIN}${image}`);

    setCanonical(path);

    trackPageView({ role, pageTitle: title });
  }, [title, description, image, path, role, lang]);

  return null;
};

export default PageMeta;
